import { _project } from "state/store.projects";
import { _bootstrap } from "state/store.bootstrap";
import { get, getFocus, useGet } from "state/jotai";
import { WDay, MDay, Month } from "./OpenHouseBanner.utilities";
import { active_project, current_language } from "state/store.global";
import { useEffect, useMemo, useState } from "react";
import { useActiveUnit } from "components/Unit";

export const useOpenHouseData = () => {
  const unit = useActiveUnit();
  const sitename = useGet(_bootstrap).sitename;
  const language = useGet(current_language);

  const openhousesRaw = get(_project, "openhouses");
  const openhouses = Array.isArray(openhousesRaw) ? openhousesRaw : [];

  const { pin, pid } = useGet(active_project);
  const buttonsLabel =
    getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];

  const isRent = unit?.isRent();

  /* -------------------------------------------------- */
  /* ✅ SAFE SORTED OPENHOUSES (LOCAL ONLY) */
  /* -------------------------------------------------- */
  const sortedOpenhouses = useMemo(() => {
    if (!unit?.data?.ProjectID) return [];
    
    return openhouses
      .filter(oh => oh.ProjectID == unit.data.ProjectID)
      .map(oh => ({ ...oh })) // ✅ clone
      .sort((a, b) => {
        const aIsRent = a.Title?.toLowerCase().includes("udlejning");
        const bIsRent = b.Title?.toLowerCase().includes("udlejning");

        // if unit is rent → rent first
        // else → sale first
        if (isRent) {
          return bIsRent - aIsRent;
        }
        return aIsRent - bIsRent;
      });
  }, [openhouses, unit?.data?.ProjectID, isRent]);

  /* -------------------------------------------------- */
  /* ✅ CURRENT OPEN HOUSE */
  /* -------------------------------------------------- */
  const cOpHouse = sortedOpenhouses[0] || {};

  /* -------------------------------------------------- */
  /* FORMATTED DATA */
  /* -------------------------------------------------- */
  const Y = sitename ?? "";
  const P = cOpHouse?.FromDate || "";
  const X = cOpHouse?.Title || "";
  const W = cOpHouse?.FromTime || "";
  const V = cOpHouse?.ToTime || "";
  const I = cOpHouse?.Address || "";
  const K = cOpHouse?.Description || "";

  const Q = `${MDay(P) ?? ""}`;
  const R = `${Month(P, language) ?? ""}`;
  const T = `${WDay(P)[0]?.toUpperCase() + WDay(P)?.slice(1)} ${
    buttonsLabel?.find(btn => btn?.UILabelProperty == "kl")?.Label
  } ${W} - ${V}`;

  return {
    /* existing API */
    ready: W && V,
    STime: W,
    ETime: V,
    MM: Q,
    MMM: R,
    Title: Y,
    Ftitle: X,
    Time: T,
    Address: I,
    Description: K,
    Date: P,

    /* 🔥 IMPORTANT: expose sorted data */
    sortedOpenhouses,
    currentOpenhouse: cOpHouse,
  };
};
